import { UserSubscriptionType } from '../../../services/subscriptions';

/**
 * Product-facing subscription tier aligned with subscription settings copy.
 * Pro entitlements are labeled Premium in the UI.
 */
export const getEffectiveSubscriptionPlan = (
  plan: UserSubscriptionType | undefined,
): UserSubscriptionType | undefined => {
  if (plan === UserSubscriptionType.Pro) {
    return UserSubscriptionType.Premium;
  }
  return plan;
};
